import {AfterViewInit, Component, inject, OnInit} from '@angular/core';
import {DecimalPipe, NgClass, NgIf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {NgbPagination, NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {NotFoundComponent} from "../../../../shared/not-found/not-found.component";
import {
  ArbitraryStatus, ArbitraryType,
  Page, ReportCondition,
  SrmHospitalArbitraryDto
} from "../../../../../generated-model/model";
import {SrmHospitalArbitraryResource} from "../../../../service/SrmHospitalArbitraryResource";
import {PageRequest} from "../../../../app.constants";
import {ShortenPipe} from "../../../../shared/commons/shorten.pipe";
import {saveAs} from "file-saver";
import {ArbitrarySearchComponent} from "../shared/arbitrary-search/arbitrary-search.component";
import {ActivatedRoute, Router} from "@angular/router";
import {SecurityService} from "../../../../security/security.service";
import {OidcSecurityService} from "angular-auth-oidc-client";
import {StaticResource} from "../../../../service/static-resource.service";
import {ConfirmDialogService} from "../../../../shared/commons/dialog/confirm-dialog/confirm-dialog.service";
import {filter} from "rxjs/operators";

export type ArbitraryMode = 'TASK' | 'NEW';

@Component({
  selector: 'app-new-work',
  standalone: true,
  imports: [
    DecimalPipe,
    FormsModule,
    NgbPagination,
    NotFoundComponent,
    NgClass,
    NgbTooltip,
    ShortenPipe,
    ArbitrarySearchComponent,

  ],
  templateUrl: './new-work.component.html',
  styleUrl: './new-work.component.scss'
})
export class NewWorkComponent implements OnInit, AfterViewInit {
  router = inject(Router)
  srmHospitalArbitraryResource = inject(SrmHospitalArbitraryResource)
  confirmDialogService = inject(ConfirmDialogService)
  private securityService = inject(SecurityService);
  private oidcSecurityService: OidcSecurityService = inject(OidcSecurityService);
  public staticResource = inject(StaticResource);
  activatedRoute = inject(ActivatedRoute)
  pageData: Page<SrmHospitalArbitraryDto> = {number: 0, size: 10};
  arbitraryMode: ArbitraryMode = 'NEW';
  isNhso: boolean = false;
  isZone: boolean = false;

  constructor() {
    this.arbitraryMode = this.activatedRoute.snapshot.data['type'];
  }

  ngAfterViewInit(): void {
    this.search()
  }

  ngOnInit(): void {
    this.oidcSecurityService.userData$.subscribe(e => {
      this.isNhso = this.securityService.isAnyAuthority(e, ["nhso"]);
      this.isZone = this.securityService.isAnyAuthority(e, ["zone"]);
    });
  }

  search(page: number = 1) {
    const pageRequest: PageRequest = {page: page - 1, size: this.pageData.size, sort: 'notiNumber,id,desc'}
    this.srmHospitalArbitraryResource.search(this.srmHospitalArbitraryResource.params(), pageRequest)
      .subscribe({
        next: e => {
          this.pageData = e
        }
      })
  }

  ARBITRARY_TYPE(value: string) {
    return ArbitraryType[value]
  }

  ARBITRARY_STATUS(value: string) {
    return ArbitraryStatus[value]
  }

  downloadExcel(item: SrmHospitalArbitraryDto) {

    let hmainOp: string = item.hmainOp.hcode;
    let notiNumber: string = item.notiNumber;
    let reportCode: string = '';

    let condition: ReportCondition = {srmHospitalArbitraryId: item.id}

    if (item.arbitraryType === 'OVER_HOUSE_NUMBER') {
      reportCode = '001';
      condition.reportPath = 'over_house_number.jasper';
    } else if (item.arbitraryType === 'IRREGULAR_SUM') {
      reportCode = '002';
      condition.reportPath = 'irregular_sum.jasper';
    } else if (item.arbitraryType === 'OVER_ATTOR') {
      reportCode = '003';
      condition.reportPath = 'over_attor.jasper';
    } else if (item.arbitraryType === 'TRANSFER_UNIT') {
      reportCode = '004';
      condition.reportPath = 'tranfer_unit.jasper';
    } else if (item.arbitraryType === 'IRREGULAR_TIME') {
      reportCode = '005';
      condition.reportPath = 'irregular_time.jasper';
    }

    condition.reportName = `${hmainOp}_${notiNumber}_${reportCode}`;
    this.srmHospitalArbitraryResource.newTaskDownloadXls(item.id).subscribe(x => {

      //download xls
      this.srmHospitalArbitraryResource.downloadExcel(condition)
        .subscribe(e => {
          saveAs(new Blob([e]), `${condition.reportName}.${condition.fileType}`)
          this.pageData.content.find(f => f.id === item.id).arbitraryStatus = x.arbitraryStatus
        });
    });
  }


  downloadLetterFile(item: SrmHospitalArbitraryDto) {
    this.srmHospitalArbitraryResource.downloadMinio(item.letterFile)
      .subscribe(e => saveAs(new Blob([e]), item.auditFile.originalName));
  }

  downloadResultExcel(item: SrmHospitalArbitraryDto) {
    if (this.isNhso) {
      this.srmHospitalArbitraryResource.newTaskDownloadResultXls(item.id).subscribe(e => {
        this.srmHospitalArbitraryResource.downloadMinio(item.auditFile)
          .subscribe(e => {
            saveAs(new Blob([e]), "result_" + item.auditFile.originalName);
            if (this.arbitraryMode === 'NEW') {
              this.srmHospitalArbitraryResource.params().arbitraryStatus = 'TEAM_EXAMINED_REPORT';
              this.search();
            }
          });
      });
    } else {
      this.srmHospitalArbitraryResource.downloadMinio(item.auditFile)
        .subscribe(e => saveAs(new Blob([e]), "result_" + item.auditFile.originalName));
    }

  }

  taskDetails(item: SrmHospitalArbitraryDto) {
    this.router.navigate(['/secure/arbitrary/tasks-details', item.id])
  }

  exportExcel() {
    this.srmHospitalArbitraryResource.downloadDataTableExcel(this.srmHospitalArbitraryResource.params())
  }

  finish(item: SrmHospitalArbitraryDto) {
    this.confirmDialogService.open({content: 'ยืนยันการส่งรายงานผลการตรวจสอบ'})
      .pipe(filter(e => !!e))
      .subscribe({
        next: e => {
          this.srmHospitalArbitraryResource.finish(item.id).subscribe(x => {
            let srmHospitalArbitraryDto = this.pageData.content.find(f => f.id === item.id);
            srmHospitalArbitraryDto.arbitraryStatus = x.arbitraryStatus;
            srmHospitalArbitraryDto.auditDetected = x.auditDetected;
          });
        }
      });
  }
}
